export default {
  methods: {
    // dd-mm-yyyy --> dd/mm/yyyy
    computerToHumanDate(dateString) {
      let date = dateString.split("-");
      return date[0] + "/" + date[1] + "/" + date[2];
    },

    // dd/mm/yyyy --> yyyy-mm-dd
    humanToComputerDate(dateString) {
      let date = dateString.split("/");
      return date[2] + "-" + date[1] + "-" + date[0];
    },

    /**
     * date_of_birth: dd/mm/yyyy
     */
    getAgeNextBirthday(date_of_birth) {
      let nextAge = this.getAge(date_of_birth) + 1;

      let dob = date_of_birth.split("/");
      let today = new Date();
      let birthDate = new Date(`${dob[2]}-${dob[1]}-${dob[0]}`);

      if (today.getMonth() == birthDate.getMonth() && today.getDate() == birthDate.getDate()) {
        nextAge--;
      }

      return !isNaN(nextAge) ? nextAge : 0;
    },

    /**
     * date_of_birth: dd/mm/yyyy
     */
    getAge(date_of_birth) {
      if (date_of_birth === undefined) date_of_birth = '';
      if (date_of_birth === '') this.ntcPrint("getAge function - WARNING! Date given is either undefined or empty string.")

      let dob = date_of_birth.split("/");
      let today = new Date();
      let birthDate = new Date(`${dob[2]}-${dob[1]}-${dob[0]}`);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return !isNaN(age) ? age : 0;
    },

    /**
     * dateString --> dd/mm/yyyy
     * return true if dateString is future
     */
    isFutureDate(dateString) {
      let date = dateString.split("/");

      let today = this.$moment();
      let dateMoment = this.$moment([date[2], (date[1] - 1), date[0]]);

      // returns true if dateString is future
      return today.diff(dateMoment) < 0;
    },

    /**
     * dateString --> dd/mm/yyyy
     * returns true if dateString is past
     */
    isPastDate(dateString) {
      return !this.isFutureDate(dateString)
    },

    /**
     * dateString --> dd/mm/yyyy
     * period --> int
     * scale --> 'months' or 'days' or 'years'
     * returns dd/mm/yyyy
     */
    addPeriod(dateString, period, scale) {
      let dateArray = dateString.split("/");
      let to_date = this.$moment([dateArray[2], (dateArray[1] - 1), dateArray[0]]).add(period, scale).subtract(1, 'days')
      let date = to_date.get('date')
      let month = to_date.get('month') + 1
      let year = to_date.get('year')

      if (date < 10) {
        date = "0" + date;
      }

      if (month < 10) {
        month = "0" + month;
      }

      return date + "/" + month + "/" + year
    },

    /**
     * date --> dd/mm/yyyy
     * returns yyyy/mm/dd
     */
    reverseDate(date) {
      date = date.replace(/[/]/g, "-");
      var day = date.split("-");
      date = `${day[2]}-${day[1]}-${day[0]}`;
      return date;
    },

    /**
     * fromDate --> dd/mm/yyyy
     * toDate --> dd/mm/yyyy
     * toDate default value --> today's date
     * returns yyyy/mm/dd
     */
    calculateMonthDifference(from, to) {
      var fDay, fMon, fYear;
      var tDay, tMon, tYear;

      if (to === undefined) {
        var today = new Date();
        tDay = today.getDate();
        tMon = today.getMonth() + 1;
        tYear = today.getFullYear();
      } else {
        to = to.split("/");
        tDay = to[0];
        tMon = to[1];
        tYear = to[2];
      }

      from = from.split("/");
      fDay = from[0];
      fMon = from[1];
      fYear = from[2];

      var diff = this.$moment([+tYear, +tMon - 1, +tDay]).diff(this.$moment([+fYear, +fMon - 1, +fDay]), 'months', true);
      return diff;
    },

    /**
     * Add Zero if date less than 10
     * format date Y-m-d
     */
    addZeroToDate(date) {
      let dateArray = date.split("-");

      dateArray[2] < 10 ? dateArray[2] = "0" + dateArray[2] : dateArray[2];

      return dateArray[0] + "-" + dateArray[1] + "-" + dateArray[2];
    },

    /**
     * Add Zero if date less than 10
     * format date dd-mm-yyyy
     */
    addZeroToDateHumanDate(date) {
      let dateArray = date.split("/");

      dateArray[0] < 10 ? dateArray[0] = "0" + dateArray[0] : dateArray[0];
      dateArray[1] < 10 ? dateArray[1] = "0" + dateArray[1] : dateArray[1];

      return dateArray[0] + "/" + dateArray[1] + "/" + dateArray[2];
    },

    /**
     * check Date
     * if format dd-mm-yyyy convert to yyyy-mm-dd
     * else
     * if yyyy-mm-dd no change
     */

    checkingDate(date) {
      let dateArray = date.split("-");

      if (dateArray[0].length > 2) {
        return dateArray[0] + "-" + dateArray[1] + "-" + dateArray[2];
      }

      return dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0];
    },

    /**
     * change yyyy-mm-dd to dd/mm/yyyy
     */

    dateFormatChange(dateString) {

      if (dateString.includes("/")) {
        return dateString;
      }
      let date = dateString.split("-");
      return date[2] + "/" + date[1] + "/" + date[0];
    },


    /**
     * return in yyyy-mm-dd format
     */
    todaysDate() {
      let todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);
      var options = { year: "numeric", month: "2-digit", day: "2-digit" };
      var formattedTodaysDate = new Intl.DateTimeFormat("en-GB", options).format(todayDate);
      formattedTodaysDate = formattedTodaysDate.replace(/ /g, "/");

      let date = formattedTodaysDate.split("/");
      return date[2] + "-" + date[1] + "-" + date[0]
    }

  }
}
